import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import '../css/Gametime.css';
import ScrollToTop from "./Tiltop";

const games = [
  { id: 1, slug: "cs2", title: "Counter-Strike 2", type: "team", image: "/cs2.png" },
  { id: 2, slug: "valorant", title: "Valorant", type: "team", image: "/valorant.png" },
  { id: 3, slug: "lol", title: "League of Legends", type: "team", image: "/lol.png" },
  { id: 4, slug: "fortnite", title: "Fortnite", type: "team", image: "/fortnit.png" },
  { id: 5, slug: "pubg", title: "Battlegrounds", type: "team", image: "/pubg.png" },
  { id: 6, slug: "tft", title: "Team Fight Tactics", type: "team", image: "/tft.png" },
  { id: 7, slug: "fifa", title: "FIFA 25", type: "team", image: "/fifa.png" },
  { id: 8, slug: "robloxminecraft", title: "Roblox / Minecraft", type: "team", image: "/Roblox-minecraft.png" },
];

// Dage med ID til backend
const days = [
  { id: 1, name: "Mandag" },
  { id: 2, name: "Tirsdag" },
  { id: 3, name: "Onsdag" },
  { id: 4, name: "Torsdag" },
  { id: 5, name: "Fredag" },
  { id: 6, name: "Lørdag" },
  { id: 7, name: "Søndag" },
];

const schedule = [
  { day: "Onsdag", sessions: [
    { game: "cs2", time: "15:00 - 17:00", level: "Begynder", spots: 10, mode: "Online" }, 
    { game: "cs2", time: "17:00 - 19:00", level: "Mellem", spots: 10, mode: "Online" }, 
    { game: "cs2", time: "19:00 - 21:00", level: "Avanceret", spots: 10, mode: "Online" }, 

    { game: "valorant", time: "15:00 - 17:00", level: "Mellem", spots: 10, mode: "Online" },
    { game: "valorant", time: "17:00 - 19:00", level: "Mellem", spots: 10, mode: "Online" },

    { game: "lol", time: "15:00 - 17:00", level: "Begynder", spots: 10, mode: "Online" },
    { game: "lol", time: "17:00 - 19:00", level: "Mellem", spots: 10, mode: "Online" },

    { game: "pubg", time: "17:00 - 19:00", level: "Mellem", spots: 8, mode: "Online" },
    { game: "pubg", time: "19:00 - 21:00", level: "Mellem", spots: 8, mode: "Online" },

    { game: "tft", time: "19:00 - 21:00", level: "Avanceret", spots: 7, mode: "Online" }

  ] },
  { day: "Søndag", sessions: [
    { game: "cs2", time: "15:00 - 17:00", level: "Begynder", spots: 8, mode: "Lokalet" },
    { game: "cs2", time: "17:00 - 19:00", level: "Mellem", spots: 8, mode: "Lokalet" },
    { game: "cs2", time: "19:00 - 21:00", level: "Mellem", spots: 8, mode: "Lokalet" },

    { game: "lol", time: "17:00 - 19:00", level: "Begynder", spots: 8, mode: "Lokalet" },
    { game: "lol", time: "19:00 - 21:00", level: "Begynder", spots: 8, mode: "Lokalet" },

    { game: "fortnite", time: "15:00 - 17:00", level: "Begynder", spots: 8, mode: "Lokalet" },
    { game: "fortnite", time: "17:00 - 19:00", level: "Begynder", spots: 8, mode: "Lokalet" },

    { game: "robloxminecraft", time: "15:00 - 17:00", level: "Mellem", spots: 8, mode: "Lokalet" },
    { game: "robloxminecraft", time: "17:00 - 19:00", level: "Mellem", spots: 8, mode: "Lokalet" },

    { game: "fifa", time: "15:00 - 17:00", level: "Begynder", spots: 2, mode: "Lokalet" },
    { game: "fifa", time: "17:00 - 19:00", level: "Mellem", spots: 2, mode: "Lokalet" },
    { game: "fifa", time: "19:00 - 21:00", level: "Mellem", spots: 2, mode: "Lokalet" },
  ] },
];

export default function TrainingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedGame, setSelectedGame] = useState(
    location.state?.selectedGame || "cs2"
  );

  const selectedGameData = games.find(game => game.slug === selectedGame);
  
  const filteredSchedule = schedule.map(day => ({
    ...day,
    sessions: day.sessions.filter(session => session.game === selectedGame),
  }));




  return (
    <main className="training-page">

    

      <section className="titel">
      <h2>Holdtider for {selectedGameData?.title}</h2>
      </section>
      <section className="undertitel">
      <p><span className="gold">Online:</span> undervisning forgår på Discord</p>
      <p><span className="gold">Lokalet:</span> undervisning forgår på Nyelandsvej 51</p>
      <p><span className="gold">kontingent:</span> er på 2000kr per 6 måned</p>

      </section>
      <section className="games-section">
        <div className="games-bar">
          {games.map(game => (
            <div
              key={game.id}
              className={`game-card ${selectedGame === game.slug ? "selected" : ""}`}
              onClick={() => setSelectedGame(game.slug)}
            >
              <img src={game.image} alt={game.title} className="game-logo" />
              <h3>{game.title}</h3>
              <span className="level">{game.type === "team" ? "Holdspil" : "Individuelt"}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="schedule-section">
        <div className="schedulespil">
          {filteredSchedule.map(day =>
            day.sessions.length > 0 && (
              <div className="day" key={day.day}>
                <h3>{day.day}</h3>
                {day.sessions.map((session, index) => {
                  // Find dag ID til backend
                  const dayId = days.find(d => d.name === day.day)?.id;
                  
                  return (
<div key={index} className="training-card">
  <p className="game_id">{selectedGameData?.title}</p>
  <p className="time">{session.time}</p>
  <p className="level"></p>
  <p className="spots">Pladser: {session.spots}</p>
  <p className="mode">Sted: {session.mode}</p>
  <p className="kontingent">Kræver kontingent</p>

  <button
    className="register-btn"
    onClick={() => {
      const dayId = days.find(d => d.name === day.day)?.id;
      navigate("/signup-academy", {
        state: {
          game_id: selectedGameData?.id,
          game: selectedGameData?.title,
          training_time: session.time,
          day: dayId,
          level: session.level,
          spots: session.spots,
          kontingent: session.kontingent,
          mode: session.mode
        }
      });
    }}
  >
    Tilmeld dig
  </button>
</div>
                  );
                })}
              </div>
            )
          )}
        </div>
      </section>
      <ScrollToTop />
    </main>
    
  );
}